<script setup lang="ts">
import type { PropertyColor, PropertySize } from "~/classes/generated/interface"

const props = defineProps({
  file: null,
  size: null,
  color: null,
  interactive: { type: Boolean }
})
const { navigateToFolder } = useNavigation()
const { viewModePropertySizes } = useViewMode()

function onPathItemClicked(folder: InterfaceFile) {
  if (props.interactive)
    navigateToFolder(folder)
}
</script>

<template>
  <div
    class="path-outer"
    :class="[viewModePropertySizes[size].textCss]"
  >
    <template v-if="file.path()?.length">
      <template
        v-for="folder in file.path()?.reverse()"
        :key="folder.fileId"
      >
        <div
          class="divider"
        />
        <div
          class="group path"
          hover=""
          :class="{ interactive }"
          @click="onPathItemClicked(folder)"
        >
          <div>
            {{ folder.name() }}
          </div>
        </div>
      </template>
    </template>
    <template v-else-if="file.isUserHomeFolder() || file.isUserArchiveFolder()">
      Root
    </template>
    <template v-else-if="file.isSharedFolderHome() || file.isSharedFolderArchive()">
      Shared Folder
    </template>
    <template v-else>
      Unknown
    </template>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.path-outer
  @apply flex
  &.t-property-xs
    @apply gap-0
  &.t-property-sm
    @apply gap-0
  &.t-property-md
    @apply gap-0.5
  &.t-property-lg
    @apply gap-0.75
  &.t-property-xl
    @apply gap-1
  &.t-property-2xl
    @apply gap-1.25

.divider
  @apply my-0.8 w-0 flex-none rotate-22 transform border-l-1.5 border-l-$global-steel-secondary

.path
  @apply flex rounded-md px-1 py-0.5
  &.interactive
    @apply cursor-pointer
    &:hover
      @apply bg-[#{$global-bg-secondary-hover}] text-[#{$global-t-default}]
    .path-folder
      @apply group-hover:text-$global-violet-primary

.path-folder
  @apply w-4 text-[#{$global-t-secondary}]
</style>
